import BanUserItem from './BanUserItem';
import { GetStreamUser } from '@bizzabo/chat-core';
import { UserRole } from '../../types/UserRole';

export interface BanUsersListProps {
    users: GetStreamUser[];
    unBanUserTriggered: (userId: string) => void;
    chatUserRole: UserRole;
}

const BanUsersList: React.FC<BanUsersListProps> = ({ unBanUserTriggered, chatUserRole, users }) => {
    return (
        <>
            {users.map(user => (
                <BanUserItem
                    key={user.id}
                    unBanUserTriggered={unBanUserTriggered}
                    user={user}
                    chatUserRole={chatUserRole}
                />
            ))}
        </>
    );
};

export default BanUsersList;
